"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LearningTableBodyCell = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const _1 = require("./");
const LearningTableBodyCell = ({ cellInfo, cellName, specificClassName, }) => {
    const cellData = React.useMemo(() => {
        let result = cellInfo[cellName];
        if (cellName === _1.LearningComponentHeaderCellEnum.Language && cellInfo.language) {
            result = cellInfo.language.join(', ');
        }
        if (cellName === _1.LearningComponentHeaderCellEnum.LearningType &&
            cellInfo.learningType === 'course') {
            result = cellInfo[cellName] + ' - ' + cellInfo.deliveryTypes.join(', ');
        }
        return result;
    }, [cellInfo, cellName]);
    return ((0, jsx_runtime_1.jsx)("span", { className: `learning-table-body-cell-text ${specificClassName} ${specificClassName ? 'max-sm:w-[80%]' : ''} ${cellName === 'duration' ? 'max-md:sr-only' : ''}`, children: cellData }));
};
exports.LearningTableBodyCell = LearningTableBodyCell;
